<div class="py-3">
  <div class="flex overflow-hidden rounded-lg border border-metro-blue">
    <table class="flex-1 border-collapse border border-metro-blue">
      <thead>
        <tr class="h-10">
          @for (col of columns; track col) {
            <th class="px-4 text-left text-sm font-medium leading-normal font-sans text-metro-black"
              [style.width]="col.width || 'auto'">
              {{ col.label | abpLocalization }}
            </th>
          }
          @if (includeActions) {
            <th class="px-4 text-left w-60 text-metro-black text-sm font-medium leading-normal font-sans">
              Acciones
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of skeletonRows; track row) {
          <tr class="border-t border-t-[#d0dee7] font-sans">
            @for (col of columns; track col) {
              <td class="h-[72px] px-4 py-2 text-sm font-normal leading-normal font-sans"
                [style.width]="col.width || 'auto'">
                <div class="skeleton-loader skeleton-value"></div>
              </td>
            }
            @if (includeActions) {
              <td class="h-[72px] px-4 py-2 w-60 font-sans">
                <div class="skeleton-loader skeleton-value"></div>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
